import { Modal } from './Modal';

export type { TypeModalProps } from './types';
export default Modal;
